import Wix from './wix-sdk-polyfill';
import { getViewMode } from './wix-sdk-utils';
import { mergeGlobalSetting } from '../actions/settings';

const _ = require('lodash');

export function listenToSiteSaved(store, sdk = Wix) {
  sdk.addEventListener(Wix.Events.SITE_SAVED, () =>
    store.dispatch(
      mergeGlobalSetting(getViewMode(), {
        fontCssUrls: getFontCssUrls(),
        siteTextPresets: Wix.Styles.getSiteTextPresets(),
        siteColors: Wix.Styles.getSiteColors(),
      }),
    ),
  );
}

function getFontCssUrls() {
  const EXCLUDED_CSS_FONTS = /fonts\.googleapis/;
  return _(document.styleSheets)
    .filter((styleSheet) => styleSheet.href)
    .map((styleSheet) => styleSheet.href.toLowerCase())
    .map((href) => href.replace(/^https?:/, ''))
    .filter((href) => !EXCLUDED_CSS_FONTS.test(href))
    .filter((href) => href.indexOf('font') >= 0)
    .uniq()
    .value();
}
